export const formatUserRole = (role: string) => {
  switch (role) {
    case 'admin':
      return 'Admin';

    default:
      return 'User';
  }
};
